import React, {PureComponent} from "react"
import Validation from "@irati/utils/validation"
import Input from "@irati/ui/src/FormItem/Input"

interface Props {
  label: string
  placeholder: string
  validation: Promise<any>
  onChange: (value: string) => void
  value?: string
}

export const teamSchema = (required = false) => {
  return Validation.string(required && "admin.helpers.getTeamSchema.validation.string")
    .min(3, "admin.helpers.getTeamSchema.validation.min")
    .max(50, "admin.helpers.getTeamSchema.validation.max")
    .matches(/.*\S.*/, "admin.helpers.getTeamSchema.validation.matches")
}

export default class TeamPublicName extends PureComponent<Props> {
  static defaultProps = {
    label: "platform.createTeamName.form.input.label",
    placeholder: "platform.createTeamName.form.input.placeholder",
    validation: teamSchema(true)
  }

  render() {
    const {label, placeholder, validation, value, onChange} = this.props

    return (
      <Input
        name="teamName"
        label={label}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        validation={validation}
      />
    )
  }
}
